import { gql, TypedDocumentNode } from "@apollo/client";
import { NOTE_GROUP_FIELDS } from "@graphql/fragments/noteGroup";

import {
  GetInboxNotesListingQuery,
  GetInboxNotesListingQueryVariables,
} from "./GetInboxNotesListing.generated";

/**
 * Lightweight version of GET_INBOX_NOTES for listing views (DashboardInbox,
 * PipNoteList) that only need card-level fields — no SOAP content, vitals,
 * physical-exam systems, or custom fields.
 */
const GET_INBOX_NOTES_LISTING: TypedDocumentNode<
  GetInboxNotesListingQuery,
  GetInboxNotesListingQueryVariables
> = gql`
  ${NOTE_GROUP_FIELDS}
  query getInboxNotesListing(
    $filter: String!
    $limit: Int
    $offset: Int
    $teamUuid: String
    $userUuids: [String]
    $startDate: DateTime
    $endDate: DateTime
    $sortAscending: Boolean
    $jobType: String
    $searchQuery: String
    $hasBeenExported: Boolean
  ) {
    inboxNotes(
      filter: $filter
      limit: $limit
      offset: $offset
      startDate: $startDate
      endDate: $endDate
      teamUuid: $teamUuid
      userUuids: $userUuids
      sortAscending: $sortAscending
      jobType: $jobType
      searchQuery: $searchQuery
      hasBeenExported: $hasBeenExported
    ) {
      totalNotes
      notes {
        uuid
        title
        createdAt
        isMadeWithScribephone
        jobType
        jobTypeName
        isNewRecording
        isMarkedAsProcessing
        isMarkedAsReview
        isApproved
        isMarkedAsFailed
        isUnacceptable
        isDraft
        hasBeenExported
        isTagged
        isIncomplete
        patient {
          name
          lastNameOfOwner
          sex
          species
          uuid
        }
        autoTemplates {
          uuid
        }
        user {
          firstName
          lastName
          uuid
        }
        noteGroup {
          ...NoteGroupFields
        }
      }
    }
  }
`;

export default GET_INBOX_NOTES_LISTING;
